import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { I18nPipe } from '../../../../shared/i18n/i18n-pipe';
import { I18nScopeReadyDirective } from '../../../../shared/i18n/i18n-scope-ready.directive';
import { provideI18nScope } from '../../../../shared/i18n/i18n-scope.provider';
import { I18nScopedService } from '../../../../shared/i18n/i18n-scoped.service';

export interface AddTimeSeriesTableResult {
  name: string;
  description: string;
}

@Component({
  selector: 'app-add-timeseries-table-dialog',
  imports: [
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    I18nPipe,
    I18nScopeReadyDirective,
  ],
  providers: [
    provideI18nScope('features/timeseries-data/add-table-dialog'),
    I18nScopedService,
  ],
  templateUrl: './add-timeseries-table-dialog.html',
  styleUrl: './add-timeseries-table-dialog.scss',
})
export class AddTimeSeriesTableDialog {
  private readonly dialogRef = inject(MatDialogRef<AddTimeSeriesTableDialog>);

  name = '';
  description = '';

  get isValid(): boolean {
    return this.name.trim().length > 0;
  }

  apply(): void {
    if (!this.isValid) return;
    this.dialogRef.close({
      name: this.name.trim(),
      description: this.description.trim(),
    } satisfies AddTimeSeriesTableResult);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
